import { render, staticRenderFns } from "./LanguagePicker.vue?vue&type=template&id=fd8bc510"
import script from "./LanguagePicker.vue?vue&type=script&lang=js"
export * from "./LanguagePicker.vue?vue&type=script&lang=js"
import style0 from "./LanguagePicker.vue?vue&type=style&index=0&id=fd8bc510&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports